var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomateWhiteGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.72917 17.1667C4.29093 17.1667 3.125 18.3326 3.125 19.7708C3.125 21.2091 4.29093 22.375 5.72917 22.375C7.16741 22.375 8.33333 21.2091 8.33333 19.7708C8.33333 18.3326 7.16741 17.1667 5.72917 17.1667ZM5.72917 17.1667V13.5M19.2708 17.1667V9.5625C19.2708 8.39573 19.2708 7.81233 19.0437 7.36669C18.8441 6.97468 18.5253 6.65597 18.1333 6.45624C17.6877 6.22917 17.1043 6.22917 15.9375 6.22917H12.5M19.2708 17.1667C20.7091 17.1667 21.875 18.3326 21.875 19.7708C21.875 21.2091 20.7091 22.375 19.2708 22.375C17.8326 22.375 16.6667 21.2091 16.6667 19.7708C16.6667 18.3326 17.8326 17.1667 19.2708 17.1667ZM12.5 6.22917L15.1042 8.83333M12.5 6.22917L15.1042 3.625",
    stroke: "#9C9CA2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 3.5C5.95484 3.5 6.32353 3.86869 6.32353 4.32353V6.17647H8.17647C8.63131 6.17647 9 6.54516 9 7C9 7.45484 8.63131 7.82353 8.17647 7.82353H6.32353V9.67647C6.32353 10.1313 5.95484 10.5 5.5 10.5C5.04516 10.5 4.67647 10.1313 4.67647 9.67647V7.82353H2.82353C2.36869 7.82353 2 7.45484 2 7C2 6.54516 2.36869 6.17647 2.82353 6.17647H4.67647V4.32353C4.67647 3.86869 5.04516 3.5 5.5 3.5Z",
    fill: "#9C9CA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomateWhiteGrey);
export default __webpack_public_path__ + "static/media/automateWhiteGrey.05c2e573f7a0f9eb84d996e18d6c43be.svg";
export { ForwardRef as ReactComponent };